import { MagicLinkFormComponent } from './magic-link-form/magic-link-form.components';

export default [ MagicLinkFormComponent];

export { MagicLinkFormComponent };
